import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from '@material-ui/core';
import type { PairingPurpose } from '@internal/spassu-code-contract';

const PAIRING_INTENT_COPY: Partial<
  Record<PairingPurpose, { title: string; body: string; confirm: string }>
> = {
  renewal: {
    title: 'Renovar a conexão desta atividade?',
    body:
      'Um código de uso único será gerado agora. O MESMO workspace local é ' +
      'reutilizado — nada é clonado de novo. A credencial atual continua ' +
      'válida até a nova ser confirmada no terminal; se a validação falhar, ' +
      'nada é revogado.',
    confirm: 'Gerar código de renovação',
  },
  recovery: {
    title: 'Recuperar a conexão desta atividade?',
    body:
      'Um código de uso único será gerado agora. O MESMO workspace local é ' +
      'reutilizado — nada é clonado de novo. A atividade e o histórico são ' +
      'preservados.',
    confirm: 'Gerar código de recuperação',
  },
  'cleanup-enrollment': {
    title: 'Atualizar o agente para concluir a exclusão?',
    body:
      'Um código de uso único instala apenas a credencial de limpeza no ' +
      'workspace existente. Nenhum acesso operacional é devolvido a esta ' +
      'atividade encerrada.',
    confirm: 'Gerar código de limpeza',
  },
};

/** Confirms the intent before any one-use pairing material is emitted. */
export function PairingIntentDialog(props: {
  purpose: PairingPurpose | null;
  busy: boolean;
  onClose(): void;
  onConfirm(purpose: PairingPurpose): void;
}) {
  const copy = props.purpose ? PAIRING_INTENT_COPY[props.purpose] : undefined;
  return (
    <Dialog
      open={Boolean(copy)}
      onClose={props.onClose}
      aria-labelledby="pairing-intent-title"
    >
      <DialogTitle id="pairing-intent-title">{copy?.title}</DialogTitle>
      <DialogContent>
        <DialogContentText>{copy?.body}</DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={props.onClose} disabled={props.busy}>
          Voltar
        </Button>
        <Button
          color="primary"
          variant="contained"
          disabled={props.busy}
          onClick={() => props.purpose && props.onConfirm(props.purpose)}
        >
          {copy?.confirm}
        </Button>
      </DialogActions>
    </Dialog>
  );
}

export function ResumeAttemptDialog(props: {
  open: boolean;
  busy: boolean;
  onClose(): void;
  onConfirm(): void;
}) {
  return (
    <Dialog
      open={props.open}
      onClose={props.onClose}
      aria-labelledby="resume-attempt-title"
    >
      <DialogTitle id="resume-attempt-title">Retomar conexão?</DialogTitle>
      <DialogContent>
        <DialogContentText>
          Uma nova autorização de uso único será gerada para continuar no mesmo
          workspace. O propósito da tentativa será preservado pelo backend.
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={props.onClose} disabled={props.busy}>
          Cancelar
        </Button>
        <Button
          color="primary"
          variant="contained"
          onClick={props.onConfirm}
          disabled={props.busy}
        >
          Confirmar retomada
        </Button>
      </DialogActions>
    </Dialog>
  );
}
